import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { AgenteFinanceiro } from './agente-financeiro.model';
import { BaseModel } from './base-model.model';

export class LimiteAportado extends BaseEntity {
    cpfCnpj: string;
	nomeAgente: string
	razaoSocial: string
	valorSubscrito: number;
	comprometido: number;
	comprometidoLegado: number;
	valorLimiteGarantia: number;
	valorDisponivel: number;
}

